import { IconButton, Typography, Theme, Box } from "@mui/material";
import { lighten } from "@mui/system";
import * as React from "react";
import { useRoomSettings } from "../context";
import CloseIcon from "@mui/icons-material/Close";

export const Header = ({ children }: { children: React.ReactNode }) => {
    const roomSettings = useRoomSettings();

    return (
        <Box sx={{ display: "flex", margin: "0.7em 1em", alignItems: "center", justifyContent: "space-between" }}>
            <Typography>{children}</Typography>
            <IconButton size="small" onClick={() => (roomSettings.sidebarState = "hidden")}>
                <CloseIcon />
            </IconButton>
        </Box>
    );
};

export const getItemHoverColor = (theme: Theme) => lighten(theme.palette.background.default, 0.2);
